// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.сustomMenuItem {
  .search-container {
    position: relative;
    width: 100%;
    transition: width 0.3s ease;
    overflow: hidden;
  }
  
  .search-container input {
    width: 100%;
  }

  .search-container.expanded {
    width: 100%;
  }

  .search-container .p-inputtext {
    padding-left: 2.5rem;
    padding-right: 2rem;
  }

  .search-container .pi {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    z-index: 1;
  }

  .search-container .pi-search {
    left: 1rem;
  }

  .search-container .pi-times {
    top: 80%;
    right: 0.75rem;
    color: #6c757d;
    transition: color 0.2s;
  }

  .search-container .pi-times:hover {
    color: #495057;
  }

  .no-border {
    border-color: rgba(0, 0, 0, 0) !important;
  }
  
}
`, "",{"version":3,"sources":["webpack://./src/ui/css/CustomMenuItem.css"],"names":[],"mappings":"AAAA;EACE;IACE,kBAAkB;IAClB,WAAW;IACX,2BAA2B;IAC3B,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,oBAAoB;IACpB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,2BAA2B;IAC3B,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,QAAQ;IACR,cAAc;IACd,cAAc;IACd,sBAAsB;EACxB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,yCAAyC;EAC3C;;AAEF","sourcesContent":[".сustomMenuItem {\n  .search-container {\n    position: relative;\n    width: 100%;\n    transition: width 0.3s ease;\n    overflow: hidden;\n  }\n  \n  .search-container input {\n    width: 100%;\n  }\n\n  .search-container.expanded {\n    width: 100%;\n  }\n\n  .search-container .p-inputtext {\n    padding-left: 2.5rem;\n    padding-right: 2rem;\n  }\n\n  .search-container .pi {\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n    z-index: 1;\n  }\n\n  .search-container .pi-search {\n    left: 1rem;\n  }\n\n  .search-container .pi-times {\n    top: 80%;\n    right: 0.75rem;\n    color: #6c757d;\n    transition: color 0.2s;\n  }\n\n  .search-container .pi-times:hover {\n    color: #495057;\n  }\n\n  .no-border {\n    border-color: rgba(0, 0, 0, 0) !important;\n  }\n  \n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
